import { inject, Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export abstract class RepositoryBase<T> {
  protected abstract readonly KEY_PATH: string;
  protected readonly db = inject(NgxIndexedDBService);

  getAll(): Observable<T[]> {
    return this.db.getAll<T>(this.KEY_PATH);
  }

  getByKey(key: IDBValidKey): Observable<T | undefined> {
    return this.db.getByKey<T>(this.KEY_PATH, key) as Observable<T | undefined>;
  }

  addOrUpdate(item: T): Observable<T> {
    return this.db.update<T>(this.KEY_PATH, item);
  }

  bulkPut(items: T[]): Observable<number[]> {
    return this.db.bulkPut<T>(this.KEY_PATH, items) as Observable<number[]>;
  }

  clear(): Observable<boolean> {
    return this.db.clear(this.KEY_PATH).pipe(map(() => true));
  }

  deleteByKey(key: IDBValidKey): Observable<boolean> {
    return this.db.delete(this.KEY_PATH, key).pipe(map(() => true));
  }

  getAllByIndex(indexName: string, indexRange: IDBKeyRange): Observable<T[]> {
    return this.db.getAllByIndex<T>(this.KEY_PATH, indexName, indexRange);
  }
}
